import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Tooltip from '@mui/material/Tooltip'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import PersonOutlineIcon from '@mui/icons-material/PersonOutline'
import { SessionTags } from './SessionTags'

interface RosHeaderProps {
  sourceInfo: { label: string; url: string } | null
  email: string | null
  name: string | null
  onNewChat: () => void
  mcpPanelOpen: boolean
  onToggleMcpPanel: () => void
  devMode: boolean
  onToggleDevMode: () => void
  sessionId?: string
  token: string | null
  tags: Record<string, string>
  onTagsChange: (tags: Record<string, string>) => void
}

export function RosHeader({ sourceInfo, email, name, sessionId, token, tags, onTagsChange }: RosHeaderProps) {
  return (
    <Box sx={{
      display: 'flex', alignItems: 'center',
      px: 2.5, py: 1.2,
      borderBottom: '1px solid',
      borderColor: 'divider',
      background: '#fff',
      minHeight: 52,
    }}>
      {/* Logo */}
      <Typography sx={{
        fontFamily: (theme) => theme.typography.h2.fontFamily,
        fontWeight: 700,
        fontSize: '1.25rem',
        color: 'primary.main',
      }}>
        Rival OS
      </Typography>

      {/* Back to source */}
      {sourceInfo && (
        <Typography
          component="a"
          href={sourceInfo.url}
          sx={{
            fontSize: '0.68rem', color: '#999', ml: 3, textDecoration: 'none',
            '&:hover': { color: '#6b8f5e', textDecoration: 'underline' },
          }}
        >
          ← {sourceInfo.label}
        </Typography>
      )}

      {/* Client / Research Domain tags for the active chat */}
      <SessionTags sessionId={sessionId} token={token} tags={tags} onTagsChange={onTagsChange} />

      <Box sx={{ flex: 1 }} />

      {/* User */}
      {(name || email) && (
        <Tooltip title={name ? email || '' : ''}>
          <Box sx={{
            display: 'flex', alignItems: 'center', gap: 0.5,
            cursor: 'pointer',
            '&:hover': { '& .user-text': { color: '#555' } },
          }}>
            <PersonOutlineIcon sx={{ fontSize: 18, color: '#999' }} />
            <Typography className="user-text" sx={{ fontSize: '0.8rem', color: '#777' }}>
              {email || name}
            </Typography>
            <KeyboardArrowDownIcon sx={{ fontSize: 16, color: '#ccc' }} />
          </Box>
        </Tooltip>
      )}
    </Box>
  )
}
